import React from 'react'
import cn from 'classnames'

import styles from './card.module.scss'

interface CardProps {
  children: React.ReactNode
  className?: string
}

export const Card: React.FC<CardProps> = ({ children, className }) => {
  return <div className={cn(styles.card, className)}>{children}</div>
}
